import { render, staticRenderFns } from "./expelForm.vue?vue&type=template&id=bc7931c6&scoped=true&"
import script from "./expelForm.vue?vue&type=script&lang=js&"
export * from "./expelForm.vue?vue&type=script&lang=js&"
import style0 from "./expelForm.vue?vue&type=style&index=0&id=bc7931c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7931c6",
  null
  
)

export default component.exports